/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMoodKid = createReactComponent("outline", "mood-kid", "IconMoodKid", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 10l.01 0", "key": "svg-1" }], ["path", { "d": "M15 10l.01 0", "key": "svg-2" }], ["path", { "d": "M9.5 15a3.5 3.5 0 0 0 5 0", "key": "svg-3" }], ["path", { "d": "M12 3a2 2 0 0 0 0 4", "key": "svg-4" }]]);

export { IconMoodKid as default };
//# sourceMappingURL=IconMoodKid.mjs.map
